module.exports = __webpack_public_path__ + "img/hotdog-top-ma002-old.b08dd789.jpg";